import { render, staticRenderFns } from "./CastMyPageTop.vue?vue&type=template&id=6224c231&scoped=true&"
import script from "./CastMyPageTop.vue?vue&type=script&lang=js&"
export * from "./CastMyPageTop.vue?vue&type=script&lang=js&"
import style0 from "./CastMyPageTop.vue?vue&type=style&index=0&id=6224c231&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6224c231",
  null
  
)

export default component.exports